import React, { useEffect, useState } from 'react';

// Styles & Assets
import styles from './ZonesSelector.module.css';

// Hooks
import { useTranslation } from 'react-i18next';
import useHttp from '../../../hooks/useHttp';

// Components
import ErrorSpinnerWrapper from '../../UI/ErrorSpinnerWrapper.tsx/ErrorSpinnerWrapper';
import SelectableButton from '../../UI/SelectableButton/SelectableButton';
import ButtonsAddDelete from '../ButtonsAddDelete/ButtonsAddDelete';

// Interfaces
import { Profile } from '../../../interfaces/Profile';
import { ProfileZone, ProfileZoneWithZone, Zone } from '../../../interfaces/Zone';
import { getEnvironmentApiUrl } from '../../../services/General';
import { ActionReducerZoneAdministration } from '../../../interfaces/Administration';
interface Props {
    profileID: Profile['id']
    currentZoneID: Zone['id'] | undefined
    setCurrentZone: React.Dispatch<React.SetStateAction<Zone | null>>
    handleDeletedZone: (zoneID: Zone['id']) => void
    handleDisableAssociation: (val: boolean) => void
    dispatchSelectedItems: React.Dispatch<ActionReducerZoneAdministration>
}

const ZonesSelector: React.FC<Props> = ({ profileID, currentZoneID, setCurrentZone, handleDeletedZone, handleDisableAssociation, dispatchSelectedItems }) => {

    const { t } = useTranslation();

    const { isLoading: loadingProfileZone, error: errorProfileZone, sendRequest: getProfileZones } = useHttp<ProfileZoneWithZone[]>();
    const { sendRequest: linkZoneProfile } = useHttp<ProfileZone>();

    const [profileZones, setProfilesZones] = useState<ProfileZoneWithZone[]>([]);


    useEffect(() => {
        if (profileID) getProfileZones({
            url: getEnvironmentApiUrl() + 'profile_zone/all',
            method: 'POST',
            body: { filter: { profile_id: profileID }, params: {} }
        }, (data) => setProfilesZones(data));
        setCurrentZone(null);
    }, [getProfileZones, profileID, setCurrentZone]);


    useEffect(() => {
        handleDisableAssociation(profileZones.length > 0);
    }, [profileZones]);

    const handleClickZone = (zoneID: Zone['id']) => {
        setCurrentZone(profileZones.find(pz => pz.zone_id === zoneID)?.Zone || null);
        dispatchSelectedItems({ type: 'RESET_REMOVE' });
    };

    const addZoneCallback = (zone: Zone) => {
        if (profileID) linkZoneProfile({
            url: getEnvironmentApiUrl() + 'profile_zone/', method: 'POST',
            body: { zone_id: zone.id, profile_id: profileID }
        }, (data) => {
            setProfilesZones(oldProfilesZones => [...oldProfilesZones, { ...data, Zone: zone }]);
            setCurrentZone(zone);
        });
    };

    const removeZoneCallback = (zoneID: Zone['id']) => {
        dispatchSelectedItems({ type: 'RESET_ADD' });
        setCurrentZone(null);
        handleDeletedZone(zoneID);
        setProfilesZones(oldProfilesZones => oldProfilesZones.filter(pz => pz.zone_id !== zoneID));
    };


    return (
        <div className={styles.zones}>
            <div className={styles.zonesList}>
                <h2>{t('zones')}</h2>
                <div className={styles.zonesOptionsContainer}>
                    <ErrorSpinnerWrapper loading={loadingProfileZone} error={errorProfileZone} sizeSpinner={18}>
                        {profileZones.map(pz =>
                            <SelectableButton
                                key={pz.zone_id}
                                label={pz.Zone.name || ''}
                                active={currentZoneID !== undefined && currentZoneID === pz.zone_id}
                                handleClick={() => handleClickZone(pz.zone_id)}
                            />
                        )}
                    </ErrorSpinnerWrapper>
                </div>
            </div>
            <ButtonsAddDelete
                zoneID={currentZoneID}
                addCallback={addZoneCallback}
                removeCallback={removeZoneCallback}
            />
        </div>
    );
};

export default ZonesSelector;